// extracted by mini-css-extract-plugin
export default {"main":"TopLeftMenu_main__YYV5H"};